import React from 'react'
import styles from './infoButton-style.css'
import Icon from '@/components/Icon/Icon'
import { infoCircle } from '@/icons/index'
import cx from 'classnames'

type InfoButtonProps = React.ComponentProps<'button'>

export function InfoButton({ children, className, ...rest }: InfoButtonProps) {
  return (
    <button className={cx([styles.infoBtn], className)} {...rest}>
      {children ? children : <Icon iconSrc={infoCircle} />}
    </button>
  )
}
